import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { CheckCircleIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core-react/i18n';

import type { ContractModalSource } from '#src/app/pages/ambassadors/landing/pageContext';

import { useContractThanks } from './hooks/useContractThanks';

type Props = {
	source: ContractModalSource | null;
	onDone: () => void;
};

export const ContractThanks: React.FC<Props> = ({ source, onDone }) => {
	useContractThanks(source);

	return (
		<div className="flex w-full flex-col items-center gap-4 text-center" data-qa="ambassadors-contract-thanks">
			<div className="bg-fill-success-weaker border-stroke-success-weak flex h-16 w-16 items-center justify-center rounded-full border">
				<CheckCircleIcon size="large" className="text-icon-success" />
			</div>
			<Text as="h2" variant="heading" size="large">
				<Translate value="corgi.ambassadors.modal.thanks_heading" />
			</Text>
			<Text as="p" className="text-typography-weak">
				<Translate value="corgi.ambassadors.modal.thanks_body" />
			</Text>
			<Button
				variant="tertiary"
				size="large"
				className="w-full"
				onClick={onDone}
				data-qa="ambassadors-contract-thanks-done"
			>
				<Translate value="corgi.ambassadors.modal.thanks_done_button" />
			</Button>
		</div>
	);
};
